import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import feature from "../assets/images/safety/features.jpg";
import v1 from "../assets/images/safety/v1.jpg";
import v2 from "../assets/images/safety/v2.jpg";
import waycalling from "../assets/images/safety/2waycalling.jpg";
import alert from "../assets/images/safety/alert.jpg";
import gps from "../assets/images/safety/gps.jpg";


const Safety = () => {
  return (
    <div>
      <div className="inner-banner">
        <Container>
          <Row>
            <Col xs={8} md={12} className="pr-0">
              <div className="contact-banner text-center">
                <h4>Safety Standards</h4>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="section">
        <Container>
          <Row>
            <Col xs={12} md={12}>
              <div className="main-title text-center">
                <h4>KEY FEATURES </h4>
                <div className="divider-center"></div>
              </div>
            </Col>
          </Row>
          <Row className="mt-20 justify-content-center">
            <Col xs={12} md={9}>
              <div className="service-content pt-40">
                <img src={feature} className="img-fluid" lt="Hive Employee Transportation And Cab Services"></img>
              </div>
            </Col>
            <Col xs={12} md={12}>
              <div className="gray-divider"></div>
            </Col>
          </Row>
        

          <Row>
            <Col xs={12} md={12}>
              <div className="gray-divider"></div>
            </Col>
          </Row>
          <Row className="mt-30">
             <Col xs={12} md={5}>
              <img
                src={waycalling}
                className="img-fluid img-animation"
                alt="logo"
              />
            </Col>
            <Col xs={12} md={7}>
              <div className="service-content pl-50">
                <h5>2-WAY CALLING</h5>
                <p>
                  • Call the driver instantly through KENT CamEye app
                  <br />
                  • If Driver’s phone is busy / out of reach - Call on Device
                  through app and on second ring it gets automatically answered
                  <br />
                  • Works like a video call for the caller and an audio call for
                  the vehicle occupants
                  <br />• Be in touch with vehicle occupants from anywhere
                </p>
              </div>
            </Col>
           
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <div className="gray-divider"></div>
            </Col>
          </Row>
          <Row className="mt-30">
            <Col xs={12} md={6}>
              <div className="service-content pt-40">
                <h5>INTELLIGENT ALERTS ON YOUR MOBILE</h5>
                <p>
                  Sends many other intelligent alerts on the admin’s mobile/web
                  portal
                </p>
                <ul>
                  <li>Over speeding</li>
                  <li>Geo-fencing</li>
                  <li>Engine idling for long duration</li>
                  <li>Place of interest entry/exit </li>
                  <li>High noise level </li>
                  <li>Reboot attempted </li>
                  <li>Power cable removed & Many More </li>
                </ul>
              </div>
            </Col>
            <Col xs={12} md={6} className="pl-50">
              <img src={alert} className="img-fluid img-animation" alt="logo" />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <div className="gray-divider"></div>
            </Col>
          </Row>
          <Row className="mt-30">
            <Col xs={12} md={5} >
              <img src={gps} className="img-fluid img-animation" alt="logo" />
            </Col>
            <Col xs={12} md={7} className="pl-50">
              <div className="service-content pt-40">
                <h5>INBUILT GPS TRACKER</h5>
                <p>
                  Gives eagle-eye view of real-time position of vehicles. If
                  multiple devices are added to account, GPS location of all the
                  devices is available simultaneously
                </p>
                <p>
                  Route Playback allows the playback of past trips on the map,
                  with a customizable playback speed
                </p>
                <p>
                  Gives analytical insights for specific duration like summary
                  of trips, distance travelled etc.
                </p>
                <div className="mt-30"></div>
                {/* <img src={gpsnew} className="img-fluid " alt="logo" /> */}
                <Row>
                  <Col md>
                      <div className="gps-card pt-27">
                        <p>
                          Real-Time GPS Location
                        </p>
                      </div>
                  </Col>
                  <Col md>
                      <div className="gps-card pt-27">
                        <p>
                          Daily Statistics Report
                        </p>
                      </div>
                  </Col>
                  <Col md>
                      <div className="gps-card pt-35">
                        <p>
                        Consolidated Analytics
                        </p>
                      </div>
                  </Col>
                  <Col md>
                      <div className="pt-35 bg-blue">
                        <p>
                        Route Playback
                        </p>
                      </div>
                  </Col>
                  
                </Row>
              </div>
            </Col>
            
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Safety;
